__turbopack_context__.v({
  "EmbedIframe": "Od7sFG_EmbedIframe",
  "EmbedIframe__Frame": "Od7sFG_EmbedIframe__Frame",
  "EmbedIframe__Frame--Fill": "Od7sFG_EmbedIframe__Frame--Fill",
});
